export function encode(decoded: string): string {
  return btoa(unescape(encodeURIComponent(decoded))).replace(/\+/g, '-').replace(/\//g, '_');
}

export function decode(encoded: string): string {
  // eslint-disable-next-line no-useless-escape
  return decodeURIComponent(escape(atob(encoded.replace(/\-/g, '+').replace(/_/g, '/'))));
}
